export default "__VITE_ASSET__5692f90f__"